import { ArrowRight, MapPin, GraduationCap, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ personalInfo }) => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-[#0D1117] pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <div className="inline-flex items-center px-4 py-2 bg-white/5 rounded-full border border-white/10">
              <MapPin className="text-[#9A7B4F] mr-2" size={16} />
              <span className="text-sm font-medium text-white/90">Based in Milan, Italy</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Hi, I'm{' '}
              <span className="bg-gradient-to-r from-[#9A7B4F] to-[#C4A76C] bg-clip-text text-transparent">
                Devansh Gupta
              </span>
            </h1>
            
            <h2 className="text-xl md:text-2xl text-white/70 font-medium">
              {personalInfo.title}
            </h2>
            
            <p className="text-lg text-white/60 leading-relaxed">
              {personalInfo.tagline}
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button
                onClick={(e) => scrollToSection(e, '#about')}
                size="lg"
                className="bg-[#9A7B4F] hover:bg-[#C4A76C] text-white transition-all group shadow-lg hover:shadow-xl"
              >
                <Sparkles className="mr-2" size={20} />
                Explore My Journey
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
              <Button
                onClick={(e) => scrollToSection(e, '#contact')}
                size="lg"
                variant="outline"
                className="border-white/20 text-white hover:bg-white/10 hover:border-white/40 transition-all"
              >
                Get in Touch
              </Button>
            </div>

            {/* Quick Info */}
            <div className="flex flex-wrap gap-6 pt-6 border-t border-white/10">
              <div className="flex items-center gap-2">
                <GraduationCap className="text-[#9A7B4F]" size={20} />
                <span className="text-sm font-medium text-white/70">{personalInfo.university}</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="text-[#9A7B4F]" size={20} />
                <span className="text-sm font-medium text-white/70">{personalInfo.location}</span>
              </div>
            </div>
          </div>

          {/* Profile Image */}
          <div className="relative">
            <div className="relative w-full aspect-square max-w-lg mx-auto">
              {/* Decorative elements */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#9A7B4F]/20 to-transparent rounded-3xl blur-3xl"></div>
              <div className="absolute -inset-4 bg-gradient-to-r from-[#9A7B4F]/10 via-transparent to-[#9A7B4F]/10 rounded-3xl animate-pulse"></div>
              
              {/* Image container */}
              <div className="relative h-full w-full rounded-3xl overflow-hidden border-2 border-white/10 shadow-2xl">
                <img
                  src="/images/profile.png"
                  alt="Devansh Gupta - Finance and Economics Student at Università Bocconi, Milan"
                  className="w-full h-full object-cover"
                  loading="eager"
                />
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0D1117]/60 via-transparent to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;